import React from 'react';
import { NavFragment } from '@paypalcorp/globalnavsdk/NavFragment';

export default class Headercontainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <NavFragment type="header" />;
  }
}
